<div *ngIf="!isLoader" class="agpr-contextualPanel">
    <agpr-scroll-panel>
        <div id="rightMenu-Accordion" class="agpr-contextualPanel-customAccordion" *ngIf="false">
            <div class="agpr-contextualPanel-inputGroup agpr-contextualPanel-detailsListBlock">
                <agpr-panel
                    header="Details"
                    *ngIf="createdBy">
                    <ul class="agpr-contextualPanel-detailsList">
                        <li class="agpr-contextualPanel-detailsListLabel">Created By</li>
                        <li class="agpr-contextualPanel-detailsListItem">{{ createdBy }}</li>
                    </ul>
                    <ul class="agpr-contextualPanel-detailsList">
                        <li class="agpr-contextualPanel-detailsListLabel">Date Created</li>
                        <li class="agpr-contextualPanel-detailsListItem">{{ getFormattedTime(createdDate, preferences.timeZone) }}</li>
                    </ul>
                    <ul class="agpr-contextualPanel-detailsList">
                        <li class="agpr-contextualPanel-detailsListLabel">Last modified</li>
                        <li class="agpr-contextualPanel-detailsListItem">{{ getFormattedTime(lastModifiedDate, preferences.timeZone) }}</li>
                    </ul>
                </agpr-panel>
            </div>
            <div class="agpr-contextualPanel-inputGroup">
                <agpr-panel header="Components">
                    <div class="agpr-storyItems">
                        <agpr-button
                            id="story.addLogo"
                            [style]="buttonTypes.secondary"
                            icon="fa-regular fa-duotone fa-circle-star"
                            label="Company Logo"
                            [disabled]="showLogoButton"
                            (click)="imageClick('logo')"
                        >
                        </agpr-button>
                        <agpr-button
                            id="story.addText"
                            [style]="buttonTypes.secondary"
                            icon="fa-regular fa-duotone fa-image"
                            label="Text"
                            [disabled]="remainingTextContents <= 0"
                            (click)="textClick()"
                        >
                            <span class="agpr-storyItem-remaining">
                                ({{ remainingTextContents }})
                            </span>
                        </agpr-button>
                        <agpr-button
                            id="story.addImage"
                            [style]="buttonTypes.secondary"
                            icon="fa-regular fa-duotone fa-image"
                            label="Image"
                            [disabled]="remainingImageContents <= 0"
                            (click)="imageClick('image')"
                        >
                            <span class="agpr-storyItem-remaining">
                                ({{ remainingImageContents }})
                            </span>
                        </agpr-button>
                        <agpr-button
                            id="story.addVideo"
                            [style]="buttonTypes.secondary"
                            icon="fa-regular fa-duotone fa-video"
                            label="Video"
                            [disabled]="remainingVideoContents <= 0"
                            (click)="videoClick()"
                        >
                            <span class="agpr-storyItem-remaining">
                                ({{ remainingVideoContents }})
                            </span>
                        </agpr-button>
                        <agpr-button
                            id="story.addAbout"
                            [style]="buttonTypes.secondary"
                            icon="fa-regular fa-duotone fa-screen-users"
                            label="About Us"
                            [disabled]="aboutUsButton"
                            (click)="toggleAboutUs()"
                        >
                        </agpr-button>
                        <agpr-button
                            id="story.addContact"
                            [style]="buttonTypes.secondary"
                            icon="fa fa-fw fa-address-card-o"
                            label="Contact"
                            [disabled]="contactButton"
                            (click)="toggleContact()"
                        >
                        </agpr-button>
                        <agpr-button
                            id="story.addLink"
                            [style]="buttonTypes.secondary"
                            icon="fa fa-fw fa-link"
                            label="Links"
                            [disabled]="linkButton"
                            (click)="toggleLink()"
                        >
                        </agpr-button>
                    </div>
                </agpr-panel>
            </div>
            <div class="agpr-contextualPanel-inputGroup">
                <agpr-panel header="Distribution Region">
                    <table class="agpr-contextualPanel-releaseTable">
                        <tr>
                            <td>Region</td>
                            <td>Remaining Release(s)</td>
                        </tr>
                        <tr>
                            <td>
                                <agpr-checkbox
                                    [(ngModel)]="regions"
                                    label="United States"
                                    (onChange)="distributionRegionChange()"
                                    [disabled]="remainingUSReleases <= 0"
                                    [value]="distributionRegionsEnum.US"
                                    [id]="distributionRegionsEnum.US"
                                ></agpr-checkbox>
                            </td>
                            <td class="agpr-contextualPanel-remainingReleasesCount">
                                {{remainingUSReleases}}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <agpr-checkbox
                                    name="distributionRegions"
                                    [(ngModel)]="regions"
                                    label="United Kingdom"
                                    (onChange)="distributionRegionChange()"
                                    [disabled]="remainingUKReleases <= 0"
                                    [value]="distributionRegionsEnum.UK"
                                    [id]="distributionRegionsEnum.UK"
                                ></agpr-checkbox>
                            </td>
                            <td class="agpr-contextualPanel-remainingReleasesCount">
                                {{remainingUKReleases}}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <agpr-checkbox
                                    name="distributionRegions"
                                    [(ngModel)]="regions"
                                    label="Canada"
                                    (onChange)="distributionRegionChange()"
                                    [disabled]="remainingCanadaReleases <= 0"
                                    [value]="distributionRegionsEnum.Canada"
                                    [id]="distributionRegionsEnum.Canada"
                                ></agpr-checkbox>
                            </td>
                            <td class="agpr-contextualPanel-remainingReleasesCount">
                                {{remainingCanadaReleases}}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <agpr-checkbox
                                    name="distributionRegions"
                                    [(ngModel)]="regions"
                                    label="North America"
                                    (onChange)="distributionRegionChange()"
                                    [disabled]="remainingNorthAmericaReleases <= 0"
                                    [value]="distributionRegionsEnum.NorthAmerica"
                                    [id]="distributionRegionsEnum.NorthAmerica"
                                ></agpr-checkbox>
                            </td>
                            <td class="agpr-contextualPanel-remainingReleasesCount">
                                {{remainingNorthAmericaReleases}}
                            </td>
                        </tr>
                    </table>
                    <a href="https://www.agilitypr.com/newswire-order" target="_blank" class="agpr-contextualPanel-orderReleases">Contact us to order more releases</a>
                </agpr-panel>
                <agpr-form-message *ngIf="showPublishErrors && (regions.length === 0)">
                    Distribution Region Required.
                </agpr-form-message>
            </div>
            <div class="agpr-contextualPanel-inputGroup agpr-contextualPanel-scheduleStoryBlock">
                <agpr-panel header="Scheduling">
                    <ng-template #panelHeader>
                        <span
                            class="fa-regular fa-circle-info agpr-contextualPanel-info"
                            tooltipPosition="top"
                            tooltipStyleClass="agpr-contextualPanel-info-tooltip"
                            [pTooltip]="getLocalizedStringWithEditingDelay(localization.pressReleaseXMinuteMinimum)"
                        ></span>
                    </ng-template>
                    <agpr-delivery-scheduler
                        inputId="newsRightSidebarDelivery"
                        infoIconStyleClass="agpr-contextualPanel-info"
                        infoTooltipStyleClass="agpr-contextualPanel-info-tooltip"
                        [disabled]="statusId != null && statusId != statusEnum.Draft"
                        [minDate]="minDate"
                        [messages]="getDeliveryDateErrorMessages()"
                        [minDateValidationMessage]="getLocalizedStringWithEditingDelay(localization.allowXMinutes)"
                        [immediateOptionLabel]="localization.publishNow"
                        [futureOptionLabel]="localization.publishLater"
                        [(selectedSchedulingType)]="schedulingType"
                        [(deliveryDate)]="scheduledDate"
                        [(time)]="scheduledTime"
                        (deliveryDateChange)="scheduledDateSelected($event)"
                        (timeChange)="emitScheduledTimeChange($event)"
                        (selectedSchedulingTypeChange)="schedulingTypeSelected($event)"
                    >
                    </agpr-delivery-scheduler>
                </agpr-panel>
            </div>
            <div class="agpr-contextualPanel-inputGroup agpr-contextualPanel-subjectBlock">
                <agpr-panel header="Additional Information">
                    <div class="u-smallBottomMargin">
                        <div>
                            Industry
                            <span
                                class="fa-regular fa-circle-info agpr-contextualPanel-info"
                                tooltipPosition="top"
                                tooltipStyleClass="agpr-contextualPanel-info-tooltip"
                                [pTooltip]="localization.newswireIndustryInfo"
                            >
                            </span>
                        </div>
                        <agpr-dropdown
                            placeholder="Select Industry"
                            [options]="industryList"
                            [(ngModel)]="selectedIndustry"
                            (ngModelChange)="industrySelected()"
                        ></agpr-dropdown>
                    </div>
                    <agpr-form-message *ngIf="showPublishErrors && !isIndustryIDSet()">
                        {{ localization.industryRequired }}
                    </agpr-form-message>
                    <div>
                        Metadata Description
                        <span
                            class="fa-regular fa-circle-info agpr-contextualPanel-info"
                            pTooltip="The meta description is a snippet which summarizes the page content. Search engines show the meta description in search results."
                            tooltipPosition="top"
                            tooltipStyleClass="agpr-contextualPanel-info-tooltip"
                        ></span>
                    </div>
                    <textarea pInputTextarea
                        class="u-fullWidth"
                        [rows]="1"
                        [maxLength]= "200"
                        [(ngModel)]="metaData"
                        (ngModelChange)="metaDataChanged()"
                    ></textarea>
                </agpr-panel>
            </div>
            <div class="agpr-contextualPanel-inputGroup agpr-contextualPanel-scheduleStoryBlock">
                <agpr-panel header="Contact Information">
                    <ng-template #panelHeader>
                        <span
                            class="fa-regular fa-circle-info agpr-contextualPanel-info"
                            pTooltip="Accesswire may use this contact information to address any issues with the content of this Press Release. This information will not be published publicly."
                            tooltipPosition="top"
                            tooltipStyleClass="agpr-contextualPanel-info-tooltip"
                        ></span>
                    </ng-template>
                    <div class="u-smallBottomMargin">
                        <div>Name</div>
                        <input type="text" pInputText
                            class="u-fullWidth"
                            [(ngModel)]="contactName"
                            [maxLength]="256"
                            (ngModelChange)="contactNameChanged()"
                        />
                        <agpr-form-message *ngIf="showPublishErrors && (!contactName || contactName.trim() === '')">
                            Contact Name Required.
                        </agpr-form-message>
                    </div>

                    <div class="u-smallBottomMargin">
                        <div>Phone Number</div>
                        <input type="text" pInputText
                            class="u-fullWidth"
                            [(ngModel)]="contactPhone"
                            [maxLength]="256"
                            (ngModelChange)="contactPhoneChanged()"
                        />
                        <agpr-form-message *ngIf="showPublishErrors && (!contactPhone || contactPhone.trim() === '')">
                            Contact Phone Number Required.
                        </agpr-form-message>
                    </div>

                    <div class="u-smallBottomMargin">
                        <div>Email Address</div>
                        <input type="text" pInputText
                            class="u-fullWidth"
                            [(ngModel)]="contactEmail"
                            [maxLength]="256"
                            (ngModelChange)="contactEmailChanged()"
                        />
                        <agpr-form-message *ngIf="(showPublishErrors || showDraftErrors) && ((contactEmail || contactEmail?.trim().length > 0) && !validContactEmail)">
                            {{localization.contactEmailErrorMessage}}
                        </agpr-form-message>
                        <agpr-form-message *ngIf="showPublishErrors && (!contactEmail || contactEmail?.trim() === '')">
                            Contact Email Required.
                        </agpr-form-message>
                    </div>
                    <ng-container *ngIf="preferredMethodList && preferredMethodList.length > 0">
                        <div>Preferred Method of contact</div>
                        <agpr-dropdown
                            placeholder="Select Method"
                            [options]="preferredMethodList"
                            [(ngModel)]="selectedContactMethod"
                            (ngModelChange)="preferredMethodSelected()"
                        ></agpr-dropdown>
                        <agpr-form-message *ngIf="showPublishErrors && (preferredMethodId === null)">
                            Preferred Method of Contact Required.
                        </agpr-form-message>
                    </ng-container>
                </agpr-panel>
            </div>
            <div class="agpr-contextualPanel-inputGroup agpr-contextualPanel-scheduleStoryBlock">
                <agpr-panel header="Notes for editor">
                    <ng-template #panelHeader>
                        <span
                            class="fa-regular fa-circle-info agpr-contextualPanel-info"
                            pTooltip="All content is subject to an editorial review. Leave notes for the editor to consider during the review process."
                            tooltipPosition="top"
                            tooltipStyleClass="agpr-contextualPanel-info-tooltip"
                        ></span>
                    </ng-template>
                    <textarea pInputTextarea
                        class="u-fullWidth"
                        [rows]="1"
                        [(ngModel)]="notesForEditor"
                        [maxLength]="2000"
                        (ngModelChange)="notesForEditorChanged()"
                    ></textarea>
                </agpr-panel>
            </div>
            <ng-content></ng-content>
        </div>
        <div id="rightMenu-Accordion" class="agpr-contextualPanel-customAccordion" *ngIf="true">
            <div class="agpr-contextualPanel-bigActionList">
                <agpr-button
                    *ngIf="reservedUrl && statusId !== statusEnum.Retracted"
                    icon="agpr-i-view-preview"
                    label="View Preview"
                    [style]="buttonTypes.big"
                    (click)="openTab(reservedUrl)"
                ></agpr-button>
                <agpr-button
                    *ngIf="reportUrl && statusId !== statusEnum.Retracted"
                    icon="agpr-i-view-statistics"
                    label="View Statistics"
                    [style]="buttonTypes.big"
                    (click)="openTab(reportUrl)"
                ></agpr-button>
            </div>
            <div class="agpr-contextualPanel-inputGroup agpr-detailListsListBlock">
                <agpr-panel header="Details">
                    <div class='agpr-readOnlyDetails'>
                        <table class='agpr-readOnlyDetails-table'>
                            <tr>
                                <th class='agpr-readOnlyDetails-tableHeading'>Created By</th>
                                <td>{{ createdBy }}</td>
                            </tr>
                            <tr>
                                <th class='agpr-readOnlyDetails-tableHeading'>Date Created</th>
                                <td>{{ getFormattedTime(createdDate, preferences.timeZone) }}</td>
                            </tr>
                            <tr>
                                <th class='agpr-readOnlyDetails-tableHeading'>Last Modified</th>
                                <td>{{ getFormattedTime(lastModifiedDate, preferences.timeZone) }}</td>
                            </tr>
                            <tr *ngIf="publishedDate">
                                <th class='agpr-readOnlyDetails-tableHeading'>Published Date</th>
                                <td>{{ getFormattedTime(publishedDate, timeZone) }}</td>
                            </tr>
                            <tr *ngIf="!publishedDate">
                                <th class='agpr-readOnlyDetails-tableHeading'>Scheduled Date</th>
                                <td>{{ getFormattedTime(scheduledDate, timeZone) }}</td>
                            </tr>
                        </table>
                        <div class='agpr-readOnlyDetails-label'>Distribution Region(s)</div>
                        <ng-container
                            *ngIf="regions.length > 0"
                        >
                            <div *ngFor="let region of regions">
                                <div *ngIf="region === distributionRegionsEnum.US">United States</div>
                                <div *ngIf="region === distributionRegionsEnum.UK">United Kingdom</div>
                                <div *ngIf="region === distributionRegionsEnum.Canada">Canada</div>
                                <div *ngIf="region === distributionRegionsEnum.NorthAmerica">North America</div>
                            </div>
                        </ng-container>
                        <div class='agpr-readOnlyDetails-label'>Industry</div>
                        <div>{{ selectedIndustry?.label }}</div>
                        <div class='agpr-readOnlyDetails-label'>Metadata Description</div>
                        <div>{{metaData}}</div>
                        <div class='agpr-readOnlyDetails-label'>Contact Information</div>
                        <div>{{contactName}}</div>
                        <div>{{contactPhone}}</div>
                        <div>{{contactEmail}}</div>
                        <div>Preferred method of contact: {{ selectedContactMethod?.label }}</div>
                        <div *ngIf='notesForEditor' class='agpr-readOnlyDetails-label'>Notes for editor</div>
                        <div *ngIf='notesForEditor'>{{notesForEditor}}</div>
                    </div>
                </agpr-panel>
                <!--<agpr-panel header="Press Release Inquiries">
                    <div class='agpr-readOnlyDetails'>
                        <div>For any questions or concerns regarding this Press Release please contact Accesswire.</div>
                        <div>Phone: 888.952.4446 x1</div>
                        <div>Email: <a href='mailto:cs@accesswire.com' class='agpr-readOnlyDetails-link'>cs@accesswire.com</a></div>
                    </div>
                </agpr-panel>-->
            </div>
        </div>
    </agpr-scroll-panel>
</div>
